import svg from './row-svg/surface-parcelle-v1.svg';
import { FixMe } from '@greenkub-fronts/shared/interface';

export function SurfaceParcelleV1Icon(props: FixMe) {
  return <img {...props} src={svg} alt="svg" />;
}

export default SurfaceParcelleV1Icon;
